module.exports = __webpack_public_path__ + "img/little_girls_9_01.71cf18b7.jpg";